import { Injectable } from '@angular/core';
import { AuthorizationsObject, OAuthProfile } from '@dat/angular-auth';
import { snakeCase } from 'lodash';
import {
    ApplicationInfo,
    Capabilities,
    EventRow,
    IdentifyTracking,
    TrackingEvent,
} from './iq-tracking-segment.models';

@Injectable({
    providedIn: 'root',
})
export class IqTrackingSegmentMapperService {
    constructor() {}

    track(
        trackingEvent: TrackingEvent,
        rowEvent: EventRow,
        appInfo: ApplicationInfo,
    ) {
        return {
            ...appInfo,
            ...trackingEvent.props,
            intiator: rowEvent.Initiator,
            interaction_gesture: trackingEvent.interaction,
        };
    }

    userInfo(userProfile: OAuthProfile): Partial<{
        application_mode?: '' | 'Demo' | 'Freemium' | 'Paid';
        application_version?: string;
        dat_primary_application?: string;
        tracking_version?: string;
        name?: string;
        user_id?: string;
        csb_user_id?: number;
    }> {
        return {
            csb_user_id: userProfile.csbId,
        };
    }

    identify(
        payload: {
            application_mode?: '' | 'Demo' | 'Freemium' | 'Paid';
            application_version?: string;
            dat_primary_application?: string;
            tracking_version?: string;
            traits?: any
        },
        userProfile: OAuthProfile,
        authObj: AuthorizationsObject,
    ): IdentifyTracking {
        const name = userProfile.name;
        const capabilities: Capabilities = this.capabilities(authObj);
        const { traits, ...rest } = payload;

        return {
            ...rest,
            ...traits,
            ...capabilities,
            name,
            user_id:
                userProfile?.oAuthId ||
                `${userProfile?.csbId}` ||
                'unknown auth0 subject',
            csb_user_id: userProfile.csbId,
        };
    }
    capabilities(authObj: AuthorizationsObject): Record<string, boolean> {
        return (
            authObj?.permissions?.reduce(
                (
                    currentCapabilities: {
                        [key: string]: boolean;
                    },
                    permission: string,
                ): {
                    [key: string]: boolean;
                } => this.addCapability(permission, currentCapabilities),
                {},
            ) ?? {}
        );
    }

    addCapability(
        permission: string,
        currentCapabilities: {
            [key: string]: boolean;
        },
    ): {
        [key: string]: boolean;
    } {
        const capabilityKey: string = this.mapCapabilityKey(permission);

        return {
            ...currentCapabilities,
            [capabilityKey]: true,
        };
    }

    mapCapabilityKey(permission: string): string {
        return `cp_${snakeCase(permission)}`;
    }
}
